// Channel Commands
export const PULSE = "p";
export const TOGGLE = "t";
export const ON = "1";
export const OFF = "0";
export const X = "x";
export type COMMANDS =
  | typeof ON
  | typeof OFF
  | typeof PULSE
  | typeof TOGGLE
  | typeof X;

export type Mask = COMMANDS[];
export interface MaskServer {
  mask: string;
}
export interface Commands<T> {
  [url: string]: T;
}

export interface CommandServer<T> {
  data: T;
  url: string;
}
